/** Resolve a public asset path to a root-absolute URL.
 *
 * Assets live in /public and are served at the site root, so `assets/x.jpg`
 * becomes `/assets/x.jpg` — resolving the same regardless of the current
 * hash route. Also exposed as window.RES so the <image-slot> custom element
 * (which reads window.RES when present) resolves its src identically. */
export function res(p: string): string {
  if (!p) return p;
  if (p.startsWith('assets/')) return '/' + p;
  return p;
}

declare global {
  interface Window {
    RES?: (p: string) => string;
    omelette?: { writeFile?: (name: string, content: string) => unknown };
  }
}

if (typeof window !== 'undefined') {
  window.RES = res;
}
